// extracted by mini-css-extract-plugin
export default {"external":"a007oq","icon":"b007oq"};